import { CheckoutAttribution, GoogleAttribution } from 'api';
import { getCookie } from 'utils/cookies';
import { int } from 'utils/math';
import {
  GOOGLE_CLICK_ID_COOKIE_PATTERN,
  GOOGLE_CLIENT_ID_COOKIE,
  GOOGLE_CLIENT_ID_COOKIE_PATTERN,
  GOOGLE_GBRAID_COOKIE,
  GOOGLE_GBRAID_COOKIE_PATTERN,
  GOOGLE_GCLID_COOKIE,
  GOOGLE_SESSION_COOKIE,
  GOOGLE_SESSION_COOKIE_PATTERN,
  GOOGLE_WBRAID_COOKIE,
} from './constants';

const matchCookie = (name: string, pattern: RegExp): string | undefined =>
  getCookie(name)?.match(pattern)?.[1];

const getGoogleSessionId = (): number | undefined => {
  const sessionId =
    GOOGLE_SESSION_COOKIE &&
    matchCookie(GOOGLE_SESSION_COOKIE, GOOGLE_SESSION_COOKIE_PATTERN);

  return sessionId ? int(sessionId) : undefined;
};

export const getCheckoutAttribution = (): CheckoutAttribution | undefined => {
  const google: GoogleAttribution = {
    gclid: matchCookie(GOOGLE_GCLID_COOKIE, GOOGLE_CLICK_ID_COOKIE_PATTERN),
    wbraid: matchCookie(GOOGLE_WBRAID_COOKIE, GOOGLE_CLICK_ID_COOKIE_PATTERN),
    gbraid: matchCookie(GOOGLE_GBRAID_COOKIE, GOOGLE_GBRAID_COOKIE_PATTERN),
    clientId: matchCookie(
      GOOGLE_CLIENT_ID_COOKIE,
      GOOGLE_CLIENT_ID_COOKIE_PATTERN,
    ),
    sessionId: getGoogleSessionId(),
  };

  return Object.values(google).some((value) => value !== undefined)
    ? { google }
    : undefined;
};
